import yup from '../../../config/yup';

export const sftpReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('sftpReader'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  addSftpCredentials: yup.boolean().default(false),
  format: yup.string(),
  properties: yup.object().shape({
    debug: yup.boolean(),
    credentialType: yup.string(),
    host: yup.string(),
    user: yup.string(),
    password: yup.string(),
    privateKey: yup.string(),
    passphrase: yup.string(),
    port: yup.number().positive('Port must be a positive number'),
    path: yup.string().required('Path is required'),
    filePattern: yup.string(),
  }),
});
